import React, { FC } from 'react'
import classes from './styles.module.scss'
import FullscreenClose from './fullscreen-close.component';

interface IProps {
    link: string;
    title: string;
    noClose?: boolean;
}

const IFrameFullscreen: FC<IProps> = ({ link, title, noClose }) => {
    if (!link) return null;
    return (
        <div className={classes['iframe-fullscreen']} >
            {!noClose && <FullscreenClose />}
            <iframe src={link} title={title} width="100%" height="100%" style={{ paddingTop: noClose ? '0' : '3rem' }} />
        </div>
    )
}

export default IFrameFullscreen